import React from 'react';
import PropTypes from 'prop-types';

const Article = ({
  path,
  title,
  description,
  contentType,
  image,
  createdAt,
  updatedAt,
}) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          name: title,
          headline: title,
          description: description,
          mainEntityOfPage: `https://www.education.com${path}`,
          articleSection: contentType,
          image: image,
          dateCreated: createdAt,
          datePublished: createdAt,
          dateModified: updatedAt || createdAt,
          thumbnailUrl: image,
          author: {
            '@type': 'Thing',
            name: 'education.com',
          },
          publisher: {
            '@type': 'Organization',
            name: 'education.com',
            logo: {
              '@type': 'ImageObject',
              url: 'https://www.education.com/i/logo/EDU-Logo-new-286x60.png',
              width: 286,
              height: 60,
            },
          },
        }),
      }}
    />
  );
};

Article.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
};

export default Article;
